import request from "@/utils/request";

// 全部-用户列表(t)
export function userList(data) {
  return request({
    url: `/app/ddxk/role/v1/userList`,
    method: "post",
    data: data
  });
}
// 督导/巡课权限:
export function supervisionGroupByUserId(userId) {
  return request({
    url: `/app/ddxk/role/v1/supervisionGroupByUserId?userId=${userId}`,
    method: "get",
  });
}
// 全部-角色列表(t)
export function rolePageList(data) {
  return request({
    url: `/app/ddxk/role/v1/rolePageList`,
    method: "post",
    data: {
      filterFieldOne: 2,
      ...data
    }
  });
}
// 用户授权角色
export function authRole(data) {
  return request({
    url: `/app/ddxk/role/v1/authRole`,
    method: "post",
    data: data
  });
}

// 给角色分配左侧菜单
export function authRoleMenu(data) {
  return request({
    url: `/app/ddxk/role/v1/authRoleMenu`,
    method: "post",
    data: data
  });
}

// 取消用户的角色
export function cancelUserRole(roleId,userId) {
  return request({
    url: `/app/ddxk/role/v1/cancelUserRole?roleId=${roleId}&userId=${userId}`,
    method: "get",
  });
}
// 删除角色
// export function deleteById(roleId) {
//   return request({
//     url: `/app/ddxk/role/v1/deleteById?roleId=${roleId}`,
//     method: "get",
//   });
// }
export function deleteById(roleIdList) {
  return request({
    url: `/app/ddxk/role/v1/deleteByIds`,
    method: "post",
    data: roleIdList
  });
}
// 获取菜单树
export function getMenuTree() {
  return request({
    url: `/app/ddxk/role/v1/getMenuTree`,
    method: "get",
  });
}
// 根据角色查询所有菜单
export function getRoleMenu(roleId) {
  return request({
    url: `/app/ddxk/role/v1/getRoleMenu?roleId=${roleId}`,
    method: "get",
  });
}
// 全部角色列表
export function roleList() {
  return request({
    url: `/app/ddxk/role/v1/roleList`,
    method: "get",
  });
}

// 新增或修改角色
export function saveOrUpdate(data) {
    return request({
      url: `/app/ddxk/role/v1/saveOrUpdate`,
      method: "post",
      data: data
    });
  }
//全部-重置密码(t)
export function resetPwd(data) {
    return request({
      url: `/base/user/v1/reset/pwd`,
      method: "post",
      data: data
    });
  }
//获取菜单权限
export function getRoleMenuByUserId(userId,menuName) {
    return request({
      url: `/app/ddxk/role/v1/getRoleMenuByUserId?userId=${userId}&menuName=${menuName}`,
      method: "get",
    });
  }



  
//同步用户
export function syncUser() {
    return request({
      url: `buttjoint/open/sso/sync/user`,
      method: "get",
    });
  }
